// All Hebrew UI strings + label maps in one place. Never hard-code text in views.
//
// "One place" is now this composition rather than one 1126-line file. The strings live
// in strings/<domain>.js, one file per area, because every feature touched the single
// file and parallel work collided there by construction. Leads work and money work now
// land in different files.
//
// What this file guarantees is that nothing downstream noticed: all 92 screens import
// `he` as a default import — not one named or destructured import among them — so
// composing the parts back into the same object leaves every call site reading exactly
// as before.
//
// Each top-level key is owned by EXACTLY ONE part, which is what keeps this a one-level
// spread rather than a deep merge. Deep merge is where a refactor like this usually goes
// wrong; it is not needed, so it is not used. The price is that common / empty / nav stay
// shared in strings/shared.js — a real guarantee is worth more than that marginal gain.
//
// he.snapshot.test.js holds both halves: the 756 leaf paths still resolve to the same
// values, and no two parts claim the same key — a collision object spread would
// otherwise resolve in silence, dropping a whole section.
import shared from './strings/shared';
import alerts from './strings/alerts';
import myDay from './strings/myDay';

import dashboard from './strings/dashboard';
import leads from './strings/leads';
import clients from './strings/clients';
import retainers from './strings/retainers';
import jobs from './strings/jobs';
import money from './strings/money';
import expenses from './strings/expenses';
import settlements from './strings/settlements';
import documents from './strings/documents';
import clientDocuments from './strings/clientDocuments';
import calendar from './strings/calendar';
import settings from './strings/settings';
import users from './strings/users';
import notes from './strings/notes';
import moneyScreen from './strings/moneyScreen';
import lists from './strings/lists';

const he = {
  ...shared,
  ...alerts,
  ...myDay,

  ...dashboard,
  ...leads,
  ...clients,
  ...retainers,
  ...jobs,
  ...money,
  ...expenses,
  ...settlements,
  ...documents,
  ...clientDocuments,
  ...calendar,
  ...settings,
  ...users,
  ...notes,
  ...moneyScreen,
  ...lists,
};

export default he;
